<div class="entity-config-page container-fluid px-0 py-0 py-lg-1">
  <div class="entity-config-shell d-flex flex-column gap-3 mx-auto">
    <div class="d-inline-flex rounded-4 border bg-white p-1 shadow-sm align-self-start">
      <button
        type="button"
        class="btn btn-sm rounded-3 px-4 py-2 fw-semibold btn-primary-dark text-white"
        @click="go_to_template_forms_tab('forms')"
      >
        Forms
      </button>
      <button
        type="button"
        class="btn btn-sm rounded-3 px-4 py-2 fw-semibold btn-light text-secondary border-0 bg-transparent"
        @click="go_to_template_forms_tab('workflows')"
      >
        Workflows
      </button>
    </div>

    <section class="entity-config-top rounded-4 overflow-hidden shadow-sm">
      <div class="entity-config-top-hero px-2 px-md-3 py-3">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">
              {{ resolved_template_form_name ? `${resolved_template_form_name} - question mapping` : 'Template question mapping' }}
            </h1>
            <p class="entity-page-subtitle text-white mb-0">
              Match each onboarding question to its template form equivalent.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="card border border-purple border-opacity-50 shadow-sm rounded-4 overflow-hidden bg-white">
      <div class="px-3 px-md-4 py-3">
        <div class="d-flex flex-wrap align-items-start align-items-md-center gap-2">
          <div class="min-w-0">
            <div class="fw-bold text-x mb-0">Question mapping</div>
            <div class="text-secondary text-xs">
              Map each template question to an onboarding form question.
            </div>
          </div>

          <button
            type="button"
            class="btn btn-outline-secondary btn-sm rounded-3 text-xs px-4 py-2 ms-md-auto"
            @click="go_to_template_form_questions"
          >
            Create Template Questions
          </button>

          <button
            v-if="template_questions.length"
            type="button"
            class="btn btn-primary-dark btn-sm rounded-3 text-xs px-4 py-2"
            @click="save_template_question_mappings"
          >
            Save
          </button>
        </div>
      </div>

      <div v-if="template_questions.length" class="form-mapping-header px-3 px-md-4 py-2">
        <div class="row g-2 align-items-center text-xxs text-uppercase fw-bold text-secondary">
          <div class="col-5 d-flex align-items-center gap-2">
            <i class="bi bi-ui-checks-grid"></i>
            <span>Template question</span>
          </div>
          <div class="col-2 text-center">
            <i class="bi bi-arrow-left-right"></i>
          </div>
          <div class="col-5 d-flex align-items-center gap-2">
            <i class="bi bi-journal-text"></i>
            <span>Onboarding form question</span>
          </div>
        </div>
      </div>

      <div class="card-body p-0">
        <div
          v-if="!template_questions.length"
          class="p-4 p-md-5 text-center text-secondary"
        >
          <div class="rounded-circle bg-warning-subtle text-warning d-inline-flex align-items-center justify-content-center mb-3 p-3 lh-1">
            <i class="bi bi-exclamation-triangle fs-4"></i>
          </div>
          <div class="fw-semibold text-x mb-1">No template questions found</div>
          <div class="text-xs">
            This form does not have template questions to map yet.
          </div>
          <button
            type="button"
            class="btn btn-primary-dark btn-sm rounded-3 text-xs px-4 py-2 mt-3"
            @click="go_to_template_form_questions"
          >
            Open Template Question Builder
          </button>
        </div>

        <div
          v-else
          class="d-flex flex-column gap-3 px-3 px-md-4 py-3"
          :class="template_questions.length > 5 ? 'form-mapping-scroll' : ''"
        >
          <div v-for="template_question in template_questions" :key="`template-q-${template_question.id}`" class="border-0">
            <div class="row g-2 align-items-center">
              <div class="col-12 col-md-5">
                <input
                  type="text"
                  class="form-control form-control-sm rounded-3 text-xs bg-white form-mapping-input"
                  :value="template_question.label"
                  disabled
                  readonly
                />
              </div>

              <div class="col-12 col-md-2 text-center">
                <div class="d-inline-flex align-items-center justify-content-center form-mapping-arrow">
                  <i class="bi bi-arrow-right"></i>
                </div>
              </div>

              <div class="col-12 col-md-5">
                <div class="d-flex align-items-center gap-2">
                  <div class="flex-grow-1 position-relative">
                    <div
                      class="form-mapping-select-shell border rounded-3 bg-white p-2"
                      :class="get_onboarding_selection_for_template(template_question.id) ? 'is-mapped border-primary' : 'is-unmapped border-secondary-subtle'"
                    >
                      <select
                        class="form-select form-select-sm border-0 p-1 form-mapping-select text-xs fw-normal"
                        :value="get_onboarding_selection_for_template(template_question.id)"
                        @change="on_change_template_mapping(template_question.id, $event.target.value)"
                      >
                        <option value="">Select onboarding question</option>
                        <option
                          v-for="onboarding_question in onboarding_questions"
                          :key="`onboarding-q-${onboarding_question.id}`"
                          :value="String(onboarding_question.id)"
                        >
                          {{ onboarding_question.label }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <span
                    class="form-mapping-status flex-shrink-0"
                    :class="get_onboarding_selection_for_template(template_question.id) ? 'is-mapped' : 'is-unmapped'"
                    title="Mapping status"
                  >
                    <i class="bi bi-check2" v-if="get_onboarding_selection_for_template(template_question.id)"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="template_questions.length"
        class="form-mapping-footer px-3 px-md-4 py-2 d-flex align-items-center gap-2 text-secondary text-xxs"
      >
        <i class="bi bi-info-circle"></i>
        <span>Map each template question to an onboarding form question.</span>
        <span class="ms-auto fw-bold">{{ mapped_questions_count }}/{{ template_questions.length }} mapped</span>
      </div>
    </section>
  </div>
</div>
